import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import type {
  LineProductionTargetRequest,
  LineProductionTargetResponse,
} from "@/types/production-targets.types";

const qk = (lineId: string) => ["production-targets", lineId] as const;

export function useLineTargets(lineId: string) {
  return useQuery<LineProductionTargetResponse[]>({
    queryKey: qk(lineId),
    queryFn: () => api.get<LineProductionTargetResponse[]>(`/api/v1/lines/${lineId}/targets`),
    enabled: !!lineId,
  });
}

/**
 * Spec 082 — a meta muda o PLANEJADO das execuções importadas daí para frente, e o planejado é o
 * denominador do Desempenho. A invalidação alcança produção e OEE por isso.
 */
export function useSaveLineTarget(lineId: string) {
  const qc = useQueryClient();
  // A tela trata o erro com mensagem própria; sem o opt-out o MutationCache global soma o dele.
  return useMutation({
    meta: { skipErrorToast: true },
    mutationFn: (payload: LineProductionTargetRequest) =>
      api.post<LineProductionTargetResponse>(`/api/v1/lines/${lineId}/targets`, payload),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: qk(lineId) });
      void qc.invalidateQueries({ queryKey: ["production"] });
      void qc.invalidateQueries({ queryKey: ["oee"] });
    },
  });
}

export function useDeleteLineTarget(lineId: string) {
  const qc = useQueryClient();
  return useMutation({
    meta: { skipErrorToast: true },
    mutationFn: (id: string) => api.delete<void>(`/api/v1/lines/${lineId}/targets/${id}`, {}),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: qk(lineId) });
      void qc.invalidateQueries({ queryKey: ["production"] });
      void qc.invalidateQueries({ queryKey: ["oee"] });
    },
  });
}
